module.exports = __webpack_public_path__ + "assets/Hijacking.5d034b70.svg";